module.exports = __webpack_public_path__ + "static/v12-8d0d3671580dad845a0160efba7055b0.jpg";